import fetch from 'fetch'
import _ from 'lodash'
import qs from 'qs'

const isLoginState = (type) => {
  return fetch({
    method: 'GET',
    url: `/v1/tpUnionLogin/${type}/checkLogin`
  })
}

const getTpPaySuccess = (subjectId, subjectType) => {
  return fetch({
    method: 'GET',
    url: `/v3/unifiedOrder/paySuccess`,
    data: {
      subjectId,
      subjectType
    }
  })
}

const authCodeRequest = (type, params) => {
	return fetch({
		method: 'GET',
		url: `/v1/tpUnionLogin/${type}/authCodeRequest`,
		data: params
	})
}

const genPhoneRequest = (type) => {
	fetch({
		method: 'GET',
		url: `/v1/tpUnionLogin/${type}/genPhoneRequest`
	})
}

const getTpUserView = (type, code) => {
	return fetch({
		method: 'POST',
		headers: {
			ContentType: 'application/x-www-form-urlencoded'
		},
		url: `/v1/tpUnionLogin/${type}/getTpUserView?code=${code}`,
	})
}

const getTpUserViewByPhoneToken = (type, phoneToken) => {
	return fetch({
		method: 'POST',
		url: `/v1/tpUnionLogin/${type}/getTpUserViewByPhoneToken`,
		data: {
			phoneToken
		}
	})
}

const getPayDetail = (subjectId, subjectType) => {
  return fetch({
    method: 'GET',
    url: `/v1/unifiedPay/payDetail`,
    data: {
      subjectId,
      subjectType
    }
  })
}

const shortUrl = (url) => {
  return fetch({
    method: 'PUT',
    url: '/v1/shortURL',
    data: {
      'originURL': url,
      'piaoniuHost': true
    }
  })
}

export default {
  shortUrl,
  getPayDetail,
  getTpPaySuccess,
  isLoginState,
	authCodeRequest,
	genPhoneRequest,
	getTpUserView,
	getTpUserViewByPhoneToken
}



// WEBPACK FOOTER //
// ./src/mods/service/tpUnionLogin.js